import React, { useEffect, useState } from 'react';
import { useChat } from '../../../context/provider/ChatProvider';
import useChatActions from '../../../hooks/chat/useChatActions';
import { useGroups } from '../../../hooks/grupos/useGroups';

const RoomList = ({ query, isNavOpen, setIsNavOpen }) => {
    const salasPrincipales =  [
        {
            descriptionRoom:"Chat - Comunicados ",
            id:"66390c3b39467bdbfeaf1f4dsdsde",
            lastMessageDate:"2024-05-07T13:44:11.827Z",
            nameRoom:"ATU",
            nameRoute:"",
            pendingMessages:1,
            urlImageRoom:"https://upload.wikimedia.org/wikipedia/commons/5/5a/Logo_ATU.png"
        },
        {
            descriptionRoom:"Alertas de seguridad",
            id:"66390c3b39467bdbfeaf1fadasdas4e",
            lastMessageDate:"2024-05-07T13:44:11.827Z",
            nameRoom:"PNP",
            nameRoute:"",
            pendingMessages:1,
            urlImageRoom:"https://play-lh.googleusercontent.com/OaNWY_o-b13auwjWxcpQKEXslfbcWmHvzb4XXVRrbze3vethzx0nDNP_5gbhb2BTqZI=w240-h480-rw"
        },
        {
            descriptionRoom:"Grupo de noticias",
            id:"66390c3b39467bdbfeaf1fadasdas4ddddde",
            lastMessageDate:"2024-05-07T13:44:11.827Z",
            nameRoom:"Noticias",
            nameRoute:"",
            pendingMessages:1,
            urlImageRoom:"https://cdn-icons-png.flaticon.com/512/3500/3500750.png"
        },

    ]

    const { joinRoom } = useChatActions();
    const { currentRoom, setCurrentRoom, userName } = useChat();
    const [ loading, setLoading ] = useState(true);
    const [ idRoom, setIdRoom ] = useState(null)

    const {
        listarGruposPorUID,
        gruposUID,
    } = useGroups();

    // Effect to load rooms on component mount
    useEffect(() => {
        const listar = async () => {
            await listarGruposPorUID()
            setLoading(false);
        }
        listar()
    }, []);

    useEffect(() =>{
        currentRoom  && setRoom(idRoom)
    },[gruposUID])


    // Handle room selection
    const handleRoomClick = async (roomID) => {
        if (currentRoom?.id === roomID) {
            return;
        }
        setRoom(roomID)
    };

    const setRoom = (roomID) => {
        const selectedRoom = gruposUID.find(room => room.id == roomID);
        selectedRoom.listarGruposPorUID = listarGruposPorUID;
        setCurrentRoom(selectedRoom);
        joinRoom({ selectedRoom, userName });
        setIsNavOpen(false);
    }

    if (loading) {
        return <div className="text-center">Cargando grupos...</div>;
    }

    return (
    <>
        <div className='border-r border-gray-800 w-[25%] lg:w-[35%] lg:flex lg:flex-col gap-2' open={isNavOpen}>

            <div className='grid grid-flow-col justify-stretch h-[15vh] text-center  lg:grid-rows-2 lg:gap-2'>

                {salasPrincipales.map(room => {
                    const { id, nameRoom, urlImageRoom, descriptionRoom, pendingMessages } = room;
                    const isActive = currentRoom?.id === id;
                    return (
                        <div 
                            key={id+nameRoom} 
                            className={`${isActive ? 'bg-blue-800' : 'bg-transparent'} items-center text-center
                            flex-col flex py-3 p-1 my-2 mx-1 cursor-pointer hover:bg-blue-800 rounded-lg:py-0 lg:m-0`}
                            onClick={() => handleRoomClick(id)}
                            style={{background: 'linear-gradient(0deg, rgba(10,22,40,1) 0%, rgba(224,230,224,0) 54%, rgba(10,22,40,1) 100%)'}}
                        >
                            <div className=' text-center justify-center flex'>
                                <img 
                                    className='w-20 lg:w-[30px] lg:h-[30px]' 
                                    alt='room-img' 
                                    src={urlImageRoom || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3aYoBJuTIzugm2Gmdkz6oY9VaHqYdHRUznyruA2s-mA&s'}
                                />
                            </div>
                            <div className=' text-center  '>
                                <span className='text-xl lg:text-xs'>{nameRoom}</span>
                            </div>
                        </div>
                    );
                })}

            </div>
            <div className=' overflow-y-auto containerScroll h-[77vh]'>
                <ul className='lg:flex lg:flex-col lg:gap-2'>
                    {
                        gruposUID.map(room => {
                            const { id, nameRoom, urlImageRoom, descriptionRoom, pendingMessages } = room;
                            const isActive = currentRoom?.id === id;
                            return (
                                <div 
                                    key={id} 
                                    className={`${isActive ? 'bg-blue-800' : 'bg-transparent'} flex py-3 p-1 my-2 mx-1
                                    cursor-pointer hover:bg-blue-800 rounded-lg justify-between lg:p-1 lg:m-0 lg:gap-1`}
                                    onClick={() => {handleRoomClick(id);setIdRoom(id)}}
                                    style={{background: 'linear-gradient(0deg, rgba(10,22,40,1) 0%, rgba(224,230,224,0) 54%, rgba(10,22,40,1) 100%)'}}
                                >
                                    <div className='w-[90%] lg:flex items-center flex lg:flex-col gap-1 lg:w-[70%]'>
                                        <img
                                            key={id}
                                            className='w-14 h-14 rounded-full' 
                                            alt='room-img' 
                                            src={urlImageRoom} 
                                        />
                                        <div className='px-2 lg:p-0 lg:w-[95%]'>
                                            <span
                                                className='text-xl lg:inline-block lg:w-[95%] lg:text-xs lg:whitespace-nowrap
                                                lg:overflow-hidden lg:text-ellipsis'
                                            >{nameRoom}</span>
                                            <div className="text-white text-xs">{descriptionRoom}</div>
                                        </div>
                                    </div>
                                    <div className='flex-col'>
                                        <div className='w-auto text-xs text-blue-600 lg:font-bold'>14:00</div>
                                        <div className='mt-2 bg-blue-500 w-6 h-6 rounded-full flex items-center justify-center text-white font-bold'>
                                            {pendingMessages||0}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </ul>
            </div>
        </div>
    </>
    );
};

export default RoomList;